import CustomTitleWithSwitch from "components/base/CustomTitleWithSwitch";
import { ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

const ReactHookFormSwitch = ({
  customTitleClass = "",
  title = "",
  titlePopoverDetail,
  tips,
  tipsPopoverDetail,
  bottomDescription,
  valueFieldName,
  extraActionOnChange = () => { },
  disabled = false,
  defaultTrue = false,
}) => {
  const dispatch = useDispatch()
  const formContext = useFormContext()
  const {
    setValue,
    watch,
    formState: { errors }
  } = formContext;
  
  const watchValue = watch(valueFieldName)

  return (<>
    <CustomTitleWithSwitch
      disabled={disabled}
      customTitleClass={customTitleClass}
      title={title}
      titlePopoverDetail={titlePopoverDetail}
      defaultValue={defaultTrue && watchValue === undefined ? true : watchValue}
      tips={tips}
      tipsPopoverDetail={tipsPopoverDetail}
      bottomDescription={bottomDescription}
      setValue={(value) => {
        setValue(valueFieldName, value, { shouldDirty: true })
        extraActionOnChange && extraActionOnChange({
          dispatch,
          formContext, 
          value,
        })
      }}
    />
    <ReactHookFormErrorMessage
      id={valueFieldName}
      errors={errors}
    />
  </>)
}

export default ReactHookFormSwitch;